import "./seoCotizador.css";

interface Paso {
    numero: string;
    texto: string;
}

interface Props {
    titulo?: string;
    pasos: Paso[];
}

export const ComoFuncionaElCotizador = ({ titulo = "Cómo funciona el cotizador", pasos }: Props) => {
    return (
        <div className="seo-cotizador-section">
            <div className="container">
                <h2 className="seo-cotizador-h2">
                    {titulo}
                </h2>
                <div className="seo-cotizador-steps">
                    {pasos.map(({ numero, texto }, index) => (
                        <div key={index} className="seo-cotizador-step">
                            <span className="seo-cotizador-step-num">
                                {numero}
                            </span>
                            <p>{texto}</p>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};
